interface MetricCardProps {
    icon: string;
    title: string;
    value: string;
    change?: number;
    subduedValue?: boolean;
}

export const MetricCard = ({ icon, title, value, change, subduedValue = false }: MetricCardProps) => {
    const isPositive = change !== undefined && change >= 0;
    const isNegative = change !== undefined && change < 0;

    return (
        <div className="metric-card">
            <div className="metric-card__header">
                <img src={icon} alt={title} className="metric-card__icon" />
                <span className="paragraph-5 metric-card__title">{title}</span>
            </div>
            <div className="metric-card__content">
                <p
                    className={`${subduedValue ? 'metric-card__value--placeholder' : 'heading-2'} metric-card__value ${
                        subduedValue ? 'metric-card__value--subdued' : ''
                    }`}
                >
                    {value}
                </p>
                {change !== undefined && (
                    <span
                        className={`paragraph-5 metric-card__change ${isPositive ? 'metric-card__change--positive' : ''} ${
                            isNegative ? 'metric-card__change--negative' : ''
                        }`}
                    >
                        {Math.abs(change)}% {isPositive ? '↗' : '↘'}
                    </span>
                )}
            </div>
        </div>
    );
};
